export const PAGE_SIZES: number[] = [5, 10, 20, 50];

// Demo session stub until real auth-derived office is available
export const USER_OFFICE = 'Adelaide';
